module.exports = __webpack_public_path__ + "img/shot.39b25398.png";